module.exports = __webpack_public_path__ + "static/media/melissa.12416eaf.png";